/**
 * AWS Configuration for EASI 2.0 Frontend
 */

export const awsConfig = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',

  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
  },

  s3: {
    audioBucket: process.env.REACT_APP_S3_AUDIO_BUCKET || '',
    reportsBucket: process.env.REACT_APP_S3_REPORTS_BUCKET || '',
  },

  dynamodb: {
    patientsTable: process.env.REACT_APP_DYNAMODB_PATIENTS_TABLE || '',
    assessmentsTable: process.env.REACT_APP_DYNAMODB_ASSESSMENTS_TABLE || '',
    auditTable: process.env.REACT_APP_DYNAMODB_AUDIT_TABLE || '',
  },

  kms: {
    keyAlias: process.env.REACT_APP_KMS_KEY_ALIAS || '',
  },
};

export function getEncryptionContext(organizationId: string, userId?: string) {
  return {
    service: 'easi',
    organization_id: organizationId,
    ...(userId && { user_id: userId }),
  };
}

export default awsConfig;
